import { Flex } from '@mantine/core';
import { flexRender, type Header } from '@tanstack/react-table';
import { ArrowDownIcon, ArrowUpIcon } from 'icons';

/**
 * HeaderCellProps type
 */
export type HeaderCellProps = {
  header: Header<any, unknown>;
};

/**
 * HeaderCell component
 * This component is used to render the header cell of a table.
 *
 * @param header
 * @constructor
 */
export const HeaderCell: React.FC<HeaderCellProps> = ({ header }) =>
  header.isPlaceholder ? null : (
    <Flex justify="space-between" h={30} align="stretch">
      <Flex
        onClick={header.column.getToggleSortingHandler()}
        sx={{
          flex: '1 1 auto',
          cursor: header.column.getCanSort() ? 'pointer' : undefined,
        }}
        align="center"
      >
        {flexRender(header.column.columnDef.header, header.getContext())}
        {{
          asc: <ArrowUpIcon />,
          desc: <ArrowDownIcon />,
        }[header.column.getIsSorted() as string] ?? null}
      </Flex>
    </Flex>
  );
